<template>
  <div class="kw_dialog_field" v-show="!hidden">
    <!-- 下拉树形式 -->
    <div v-if="value.chooseType == 1" @click="openChangeTree" :style="value.styleSet.pageFieldStyleSet?value.styleSet.pageFieldStyleSet.styleSetCode:''" kwName="pageFieldStyleSet">
      <el-form-item :class="(value.ifCanAdd==1 && value.addPageId>0)?'canAdd_item':''" :rules="!value.ifHide && (!value.styleSet || value.styleSet.showStyle!=7)?value.elRules:null" :prop="'fieldSet.'+fieldSetindex+'.defaultCheckValue'">
        <template slot="label"  v-if="value.styleSet.titleNameHide!=2">
          <img v-if="(value.styleSet.imgPosition == 3)" class="leftIcon" src="./img/quan.png"/>
          <span slot="label" :style="value.styleSet.pageFieldNameStyleSet?value.styleSet.pageFieldNameStyleSet.styleSetCode:''" class="pageFieldNameStyleSet" kwName="pageFieldNameStyleSet">{{value.fieldCnName + ":"}}<kw_icon v-if="value.styleSet.jumpIcon" type="unfold" style="padding-left: 5px;"></kw_icon></span>
        </template>
        <el-input v-popover:popover :style="('width:100%;') + (value.styleSet.pageFieldValueStyleSet?value.styleSet.pageFieldValueStyleSet.styleSetCode:'')" kwName="pageFieldValueStyleSet" class="defaultStyle" :value="(value.styleSet.priceUnit && value.defaultCheckCnName ? value.styleSet.priceUnit : '')+(value.defaultCheckCnName?value.defaultCheckCnName:'点击选择')" :disabled="(value.ifUpdate==0?true:false)" >{{value.styleSet.priceUnit && value.defaultCheckCnName ? value.styleSet.priceUnit : ''}}{{value.defaultCheckCnName?value.defaultCheckCnName:'点击选择'}}
          <el-button slot="append" icon="el-icon-grape"></el-button>
          <kw_icon v-if="(value.styleSet.jumpIcon)" type="unfold" style="padding-left: 5px;"></kw_icon>
        </el-input>
        <el-button v-if="value.ifCanAdd==1 && value.addPageId>0" type="primary" @click="toOpenAddDialogPage">新增</el-button>
      </el-form-item>
    </div>
    <template v-else-if="(value.chooseType == 2)">
      <!-- 下拉框的展现形式 -->
      <div v-if="(value.styleSet && value.styleSet.selectType!=1)">
        <el-form-item :class="(value.ifCanAdd==1 && value.addPageId>0)?'canAdd_item':''" :rules="!value.ifHide && (!value.styleSet || value.styleSet.showStyle!=7)?value.elRules:null" :prop="'fieldSet.'+fieldSetindex+'.defaultCheckValue'">
          <template slot="label" v-if="value.styleSet.titleNameHide!=2">
            <span :style="value.styleSet.pageFieldNameStyleSet?value.styleSet.pageFieldNameStyleSet.styleSetCode:''" class="pageFieldNameStyleSet" kwName="pageFieldNameStyleSet">{{value.fieldCnName+":"}}<kw_icon v-if="value.styleSet.jumpIcon" type="unfold" style="padding-left: 5px;"></kw_icon></span>
          </template>
          <!-- @focus="remoteMethod(value,value.prevFieldIndex+':'+value.nowFieldIndex+'-'+nowDataIndex)" -->
          <el-select v-if="value.dataMaxNum==1" :filterable="value.styleSet.filterable==2?false:true" v-model="value.defaultCheckValueIndex" placeholder="请选择"  :disabled="(value.ifUpdate==0?true:false)" clearable @change="bindElementChange(value,value.prevFieldIndex+':'+value.nowFieldIndex+'-'+nowDataIndex)" style="width:100%;" :style="value.styleSet.pageFieldValueStyleSet?value.styleSet.pageFieldValueStyleSet.styleSetCode:''" kwName="pageFieldValueStyleSet" @click.native="loadSelectData" :loading="value.selectLoading" loading-text="加载中">
            <el-option v-for="(dicItem,dicIndex) in value.dicList" :key="dicIndex" :style="'overflow:auto;max-width:350px;text-overflow: unset;'"
                        :label="dicItem.DIC_NAME"
                        :value="dicIndex">
            </el-option>
          </el-select>
          <!-- @focus="remoteMethod(value,value.prevFieldIndex+':'+value.nowFieldIndex+'-'+nowDataIndex)" -->
          <el-select v-else :filterable="value.styleSet.filterable==2?false:true" v-model="value.defaultCheckIndexArr" placeholder="请选择" multiple  @change="bindElementChange(value,value.prevFieldIndex+':'+value.nowFieldIndex+'-'+nowDataIndex)" :disabled="(value.ifUpdate==0?true:false)" style="width:100%;" :style="value.styleSet.pageFieldValueStyleSet?value.styleSet.pageFieldValueStyleSet.styleSetCode:''" kwName="pageFieldValueStyleSet" @click.native="loadSelectData" :loading="value.selectLoading" loading-text="加载中">
            <el-option v-for="(dicItem,dicIndex) in value.dicList" :key="dicIndex" :style="'overflow:auto;max-width:350px;text-overflow: unset;'"
                        :label="dicItem.DIC_NAME"
                        :value="dicIndex">
            </el-option>
          </el-select>
          <el-button v-if="value.ifCanAdd==1 && value.addPageId>0" type="primary" @click="toOpenAddDialogPage">新增</el-button>
        </el-form-item>
      </div>
      <!-- box框形式 -->
      <div v-else-if="(value.styleSet && value.styleSet.selectType==1)">
        <el-form-item class="Signing_form" :rules="!value.ifHide && (!value.styleSet || value.styleSet.showStyle!=7)?value.elRules:null" :prop="'fieldSet.'+fieldSetindex+'.defaultCheckValue'">
          <template slot="label" v-if="value.styleSet.titleNameHide!=2">
            <span :style="value.styleSet.pageFieldNameStyleSet?value.styleSet.pageFieldNameStyleSet.styleSetCode:''" class="pageFieldNameStyleSet" kwName="pageFieldNameStyleSet">{{value.fieldCnName+":"}}<kw_icon v-if="value.styleSet.jumpIcon" type="unfold" style="padding-left: 5px;"></kw_icon></span>
          </template>
          <template v-if="value.defaultCheckIndexArr && value.defaultCheckIndexArr.length >=0">
            <el-radio-group v-if="value.dataMaxNum==1" v-model="value.defaultCheckValueIndex" @change="bindElementChange" :disabled="(value.ifUpdate==0?true:false)" :style="value.styleSet.pageFieldValueStyleSet?value.styleSet.pageFieldValueStyleSet.styleSetCode:''" kwName="pageFieldValueStyleSet">
              <el-radio v-for="(dicItem,dicIndex) in value.dicList" :key="dicIndex" :label="dicIndex" :disabled="dicItem.NOCHECK=='true'?true:false">{{dicItem.DIC_NAME}}</el-radio>
            </el-radio-group>
            
            <el-checkbox-group v-else v-model="value.defaultCheckIndexArr" placeholder="请选择" @change="bindElementChange" :disabled="(value.ifUpdate==0?true:false)" :style="value.styleSet.pageFieldValueStyleSet?value.styleSet.pageFieldValueStyleSet.styleSetCode:''" kwName="pageFieldValueStyleSet">
              <el-checkbox v-for="(dicItem,dicIndex) in value.dicList" :key="dicIndex" :label="dicIndex" :disabled="dicItem.NOCHECK=='true'?true:false">{{dicItem.DIC_NAME}}</el-checkbox>
            </el-checkbox-group>
          </template>
        </el-form-item>
      </div>
    </template>
    <!-- 弹出层形式 -->
    <div v-else :style="value.styleSet.pageFieldStyleSet?value.styleSet.pageFieldStyleSet.styleSetCode:''" kwName="pageFieldStyleSet">
      <el-form-item :class="(value.ifCanAdd==1 && value.addPageId>0)?'canAdd_item':''" :rules="!value.ifHide && (!value.styleSet || value.styleSet.showStyle!=7)?value.elRules:null" :prop="'fieldSet.'+fieldSetindex+'.defaultCheckValue'">
        <template slot="label"  v-if="value.styleSet.titleNameHide!=2">
          <img v-if="(value.styleSet.imgPosition == 3)" class="leftIcon" src="./img/quan.png"/>
          <span slot="label" :style="value.styleSet.pageFieldNameStyleSet?value.styleSet.pageFieldNameStyleSet.styleSetCode:''" class="pageFieldNameStyleSet" kwName="pageFieldNameStyleSet">{{value.fieldCnName + ":"}}<kw_icon v-if="value.styleSet.jumpIcon" type="unfold" style="padding-left: 5px;"></kw_icon></span>
        </template>
        <el-input @click.native="openChangeDialog" :style="('width:100%;') + (value.styleSet.pageFieldValueStyleSet?value.styleSet.pageFieldValueStyleSet.styleSetCode:'')" kwName="pageFieldValueStyleSet" class="defaultStyle" :value="(value.styleSet.priceUnit && value.defaultCheckCnName ? value.styleSet.priceUnit : '')+(value.defaultCheckCnName?value.defaultCheckCnName:'点击选择')" :disabled="(value.ifUpdate==0?true:false)">
          {{value.styleSet.priceUnit && value.defaultCheckCnName ? value.styleSet.priceUnit : ''}}{{value.defaultCheckCnName?value.defaultCheckCnName:'点击选择'}}
          <el-button slot="append" icon="el-icon-search"></el-button>
          <kw_icon v-if="(value.styleSet.jumpIcon)" type="unfold" style="padding-left: 5px;"></kw_icon>
        </el-input>
        <el-button v-if="value.ifCanAdd==1 && value.addPageId>0" type="primary" @click="toOpenAddDialogPage">新增</el-button>
      </el-form-item>
    </div>
    <!-- 列表页面弹出层 -->
    <el-dialog class="zdy_dialog" v-if="ifOpen"  :visible.sync="ifOpen" title="选择" width="100%" top="1vh" append-to-body :close-on-click-modal="false" v-dialogDrag>
      <kw_list v-if="ifOpen" ref="dialog_kw_list" :initPageObj="toListJson" @dialogClickCallBack="dialogClickCallBack" @closeDialog="closeDialog" :isLimitButton="isLimitButton" :ifDialog="1"></kw_list>
    </el-dialog>
    <el-popover v-model="ifTreeOpen"
      ref="popover" 
      placement="bottom-start"
      width="280"
      trigger="click">
      <kw_tree_list v-if="ifTreeShow && toListJson.pageId > 0" ref="dialog_kw_list_tree" :initPageObj="toListJson" @dialogClickCallBack="dialogClickCallBack" @closeDialog="closeDialog" :treeType="1" :isLimitButton="isLimitButton" :ifChooseChild="value.ifChooseChild"></kw_tree_list>
    </el-popover>
    <el-dialog class="zdy_dialog" v-if="dialogInfo.ifLoad" :visible.sync="dialogInfo.ifLoad" width="100%" top="1vh" center append-to-body :close-on-click-modal="false" v-dialogDrag>
      <template slot="title"> 
          <div>
            {{(dialogInfo.pageInfo&&dialogInfo.pageInfo.menuName)?dialogInfo.pageInfo.menuName:'弹出层'}}
          </div>    
      </template>
      <kw_list v-if="dialogInfo.type==1" ref="kw_list_dialog" :initPageObj="dialogInfo.pageInfo" :isLimitButton="isLimitButton" :ifDialog="1"></kw_list>
      
      <kw_look v-else-if="dialogInfo.type==11" ref="kw_look_dialog" :pageInfo="dialogInfo.pageInfo" @goBack="dialogIframeZdyCancel" :isLimitButton="isLimitButton" :ifDialog="1"></kw_look>
      <iframe v-else-if="dialogInfo.type==999" ref="dialog999" :style="'width:100%;height:' + (windowHeight-70) + 'px;'" frameborder=0 name="showHere" scrolling=auto  :src="dialogInfo.url" ></iframe>
      <span slot="footer" v-if="dialogInfo.type==999">
        <el-button @click="dialogIframeZdyCancel">取 消</el-button>
        <el-button type="primary" @click="dialogIframeZdyConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import pageUtils from '@/js/page/pageUtil.js';
import utils from '@/js/utils/util.js';
// 图标库
import kw_icon from '@/components/kw/kw_icon.vue';
// 下拉树组件
import kw_tree_list from '@/components/list/kw_tree_list.vue';
export default {
  name: 'kw_dialog_field',
  props: {
    value: {
      type: Object,
      default: {}
    },
    nowDataId: {
      default: 0
    },
    filedIndex:{
      type:String,
      default:null
    },
    hidden:{
      type:Boolean,
      default:false
    },
    pageSetInfo:{
      type: Object,
      default: {}
    },
    // 第几条数据
    nowDataIndex:{
      type: String,
      default: ''
    },
    //按钮是否根据角色权限限制
    isLimitButton:{
      type: Boolean,
      default: false
    },
    fieldSetindex:{
      type:Number,
      defaultStatus:0
    }

  },
  data() {
    return {
      filedInfo: {},
      ifOpen:false,
      ifTreeOpen:false,
      ifTreeShow:false,
      // 弹出层组件的信息
      toListJson:{
      },
      /**
       * 弹出层组件的信息
       */
      dialogInfo:{
        ifLoad:false
      }
    };
  },
  created() {
    this.initAttach();
  },
  mounted() {
    
  },
  watch:{
  },
  computed:{
  },
  components: {
    kw_icon,
    kw_tree_list,
    kw_look:resolve => require(['@/components/look/kw_look.vue'], resolve),
    kw_list:resolve => require(['@/components/list/kw_list.vue'], resolve)
  },
  methods: {
    initAttach(chooseDataInfo){
      var that = this;
      // var showStyle = this.value.styleSet.showStyle;
      // if (showStyle == 5) {
      //   this.openChangeDialog();
      // }
      // 如果加载形式是默认全部添加 则去进行默认数据加载
      var addStyle = this.value.addStyle;
      // if(addStyle == 2) {
      //   pageUtils.autoGetDialogData(this.value,this,chooseDataInfo);
      // }
      var selectType = this.value.styleSet?this.value.styleSet.selectType:0;
      if(this.value.chooseType == 2) {
        //判断是否有当前显示值 如果有则默认拼接当前选中值作为dicList
        // if(this.value.defaultCheckValue) {
        //   var tmpDefaultValueId = this.value.defaultCheckValue.split(",")
        //   var dicOne = {
        //     DIC_ID: dataOne["T_"+tableId+"_0"],
        //     DIC_NAME: dataOne[keyName]
        //   }
        //   autoDicList.push(dicOne);
        // that.value.dicList = autoDicList;
        // }
      }
      if(addStyle == 2){
        //获取数据后转为 dicList
        pageUtils.autoGetDialogData(this.value,this,chooseDataInfo);
      } else if(chooseDataInfo) {
        //是否是弹出层新增按钮 保存数据后的回调
        // var checkDataInfo = [chooseDataInfo];
        // this.value.defaultCheckValueIndex = 0;
        // this.value.defaultCheckIndexArr = [0];
        // var detail = {};
        // detail.checkDataInfo = checkDataInfo;
        // detail.fieldOne = this.value;
        // that.dialogClickCallBack(detail);
        pageUtils.autoGetDialogData(this.value,this,chooseDataInfo);
      }
    },
    //下拉框点击时 进行下拉框数据的重新读取
    loadSelectData(){
      var that = this;
      var filedInfo = that.value;
      // 获取当前弹出层关联过滤条件
      var needFilter = filedInfo.needFilter;
      var toHtFilter = pageUtils.getFilterData(needFilter, that, that.filedIndex);
      if(toHtFilter.noInfoPrompt != '' && toHtFilter.noInfoPrompt.length > 0) {
        that.$message({
          message: toHtFilter.noInfoPrompt,
          type: 'error'
        });
      } else {
        that.$set(filedInfo,"selectLoading",true);
        // filedInfo.dicList = [];
        pageUtils.autoGetDialogData(this.value,this,null);
      }
    },
    openChangeDialog() {
      if(this.value.ifUpdate!=0) {
        var flag = this.getDialogInfo();
        if(flag) {
          this.ifOpen = true;
        }
      }
    },
    openChangeTree(){
      var that = this;
      if(that.value.ifUpdate!=0) {
        that.ifTreeShow = false;
        var flag = that.getDialogInfo();
        if(flag) {
          that.$nextTick(function(){
            that.ifTreeShow = true;
          });
        }
      }
    },
    getDialogInfo(){
      var that = this;
      var flag = true;
      var filedInfo = that.value;
      if (filedInfo.ifUpdate == 0) {
        return;
      }
      var clickPageId = 0;
      var clickTableId = 0;
      if (filedInfo.styleSet) {
        clickPageId = filedInfo.styleSet.clickPageId;
        clickTableId = filedInfo.styleSet.clickTableId;
      }
      if (filedInfo.pageDialog > 0) {
        clickPageId = filedInfo.pageDialog
      }
      if (filedInfo.relationTableId > 0) {
        clickTableId = filedInfo.dialogTableId
      }
      var tmpJsonData = "";
      // 获取当前弹出层关联过滤条件
      var needFilter = filedInfo.needFilter;
      
      var toHtFilter = pageUtils.getFilterData(needFilter, that, that.filedIndex);
      if(toHtFilter.noInfoPrompt != '' && toHtFilter.noInfoPrompt.length > 0) {
        flag = false;
        that.$message({
          message: toHtFilter.noInfoPrompt,
          type: 'error'
        });
      }
      if(flag) {
        var tmpJsonData = toHtFilter.tmpJsonData;
        var checkId = that.nowDataId?that.nowDataId:0;
        var toListJson={
          pageId: clickPageId,
          tableId: clickTableId,
          initCheckId: checkId,
          callBackType:1,
          dataMaxNum: filedInfo.dataMaxNum,
          tmpJsonData: tmpJsonData,
          ifDialog:true,
        }
        that.toListJson = toListJson;
      }
      return flag;
    },
    /**
     * 关闭弹出层
     */
    closeDialog(){
      this.ifOpen = false;
      this.ifTreeOpen = false;
    },
    /**
     * 弹出层选中后的赋值回调事件
     */
    dialogClickCallBack(detail){
      var that = this;
      var clickValue = detail.val;
      var checkDataInfo = detail.checkDataInfo;
      var fieldSetIndexArr = that.value;
      console.log("fieldSetIndexArr==========================",fieldSetIndexArr);
      var prevDefaultCheckValue = fieldSetIndexArr.defaultCheckValue;
      pageUtils.bindDialogChangeByDataArr(fieldSetIndexArr,checkDataInfo);
      
      //进行选中数据的处理
      pageUtils.confirmDialogCallBack(that, fieldSetIndexArr, that.filedIndex);
      // 调用弹出层选中的后续事件
      that.$emit('dialogFieldCallBack', fieldSetIndexArr);
      if(prevDefaultCheckValue != fieldSetIndexArr.defaultCheckValue) {
        //切换了选中值 则判断是否有关联字段使用此字段过滤，清空选中
         
      }
      that.$forceUpdate();
      // 关闭弹出层
      that.ifOpen = false;
      if(fieldSetIndexArr.dataMaxNum == 1) {
        that.ifTreeOpen = false;
        that.ifTreeShow = false;
      }
    },
    /**
     * 选中切换时的处理逻辑
     */
    bindElementChange(checkValue){
      var that = this;
      console.log("nowField=======================",that.value);
      var nowField = that.value;
      pageUtils.bindDialogChange(nowField,that);
      pageUtils.confirmDialogCallBack(that, nowField, that.filedIndex);
      // 调用弹出层选中的后续事件
      that.$emit('dialogFieldCallBack', nowField);
      that.$forceUpdate();
    },
    /**
     * 后台加载数据后 转化为dicList形式
     */
    loadDicList(that, pageDataInfo, chooseDataInfo){
      var tableId = that.value.dialogTableId;
      var autoDicList = [];
      var checkIndex = [];
      var keyName = "AFM_1";
      if(that.value.childFieldSet && that.value.childFieldSet[0].dialogFieldAliasName) {
        keyName = that.value.childFieldSet[0].dialogFieldAliasName;
      }
      var ifDefaultCheck = false;
      // if(pageDataInfo) {
        pageDataInfo.forEach((dataOne, dataIndex) => {
          var dicOne = {
            DIC_ID: dataOne["T_"+tableId+"_0"],
            DIC_NAME: dataOne[keyName]
          }
          dicOne = Object.assign(dicOne, dataOne);
          autoDicList.push(dicOne);
          if(chooseDataInfo) {
            if(dataOne["T_"+tableId+"_0"] == chooseDataInfo.mainId) {
              checkIndex.push(dataIndex);
            }
          } else if(that.value.defaultCheckValue) {
            if((","+that.value.defaultCheckValue+",").indexOf(","+dataOne["T_"+tableId+"_0"]+",") >= 0) {
              ifDefaultCheck = true;
              checkIndex.push(dataIndex);
            }
          }
        });
      // }
      if(!that.value.defaultCheckIndexArr) {
        that.value.defaultCheckIndexArr = [];
      }
      that.value.selectLoading = false;
      that.value.dicList = autoDicList;
      if(checkIndex.length > 0) {
        if(that.value.dataMaxNum==1) {
          that.value.defaultCheckValueIndex = checkIndex[0];
        } else {
          that.value.defaultCheckIndexArr = checkIndex;
        }
        if(ifDefaultCheck) {
          pageUtils.bindDialogChange(that.value,that);
        } else {
          that.bindElementChange(checkIndex);
        }
      }
      that.$forceUpdate();
    },
    /**
     * 获取父级的kwlook组件信息
     */
    getParentKwLook() {
      var tmp;
      this.$emit("getParentKwLook",val => {
          tmp = val
      });
      return tmp;
    },
    /**
     * 是否可新增为是时，进行添加页面打开功能
     */
    toOpenAddDialogPage() {
      var that = this;
      console.log("toOpenAddDialogPage===========",this.value);
      //关联添加功能
      var jumpJson = {
          pageId: this.value.addPageId,
          tableId: this.value.dialogTableId,
          callBackType: 1,
          listTableId: this.value.dialogTableId,
          pageType:5
      };
      pageUtils.toNewLookPage(that,jumpJson);
    },
    /**
     * 弹出层打开iframe时的确定按钮
     */
    dialogIframeZdyConfirm(){
      var that = this;
      that.$refs.dialog999.contentWindow.closeDialogFun=function(){
        that.dialogInfo.ifLoad = false;
      };
      that.$refs.dialog999.contentWindow.saveZdyPage();
    },
    /**
     * 弹出层打开iframe时的取消按钮
     */
    dialogIframeZdyCancel(ifRefresh,chooseDataInfo){
      var that = this;
      this.dialogInfo.ifLoad = false;
      if(ifRefresh == 1) {
        this.refreshevent(chooseDataInfo);
      }
    },
    /**
     * 刷新时的方法
     */
    refreshevent(chooseDataInfo){
      console.log("chooseDataInfo===========================",chooseDataInfo);
      //刷新加载下拉框或者弹出层的内容
      this.initAttach(chooseDataInfo);
    }
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.defaultStyleBox{background: #fff;font-size: 14px;color: #9B9B9B;display: flex;justify-content: space-between;padding:8px 15px}
.leftIcon{width:14px;height:14px;vertical-align: middle;margin-right: 5px}

</style>
<style>
.canAdd_item .el-form-item__content{display:flex !important;}
.el-scrollbar .el-scrollbar__bar.is-vertical {opacity: 1 ;}
</style>